<script>
import { mapActions } from 'vuex';
export default {
  computed: {
    daysLeft() {
      const expired = localStorage.getItem("guest_expired")
      if (!expired) return 0;

      const expireDate = new Date(expired);
      const today = new Date();

      // Разница в миллисекундах
      const diffMs = expireDate.getTime() - today.getTime();

      // Переводим в дни
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

      return diffDays > 0 ? diffDays : 0; // если срок вышел — 0
    }
  },
  methods: {
    getDayWord(num) {
      // Склонение слова "день"
      if (num % 10 === 1 && num % 100 !== 11) return 'день';
      if ([2,3,4].includes(num % 10) && ![12,13,14].includes(num % 100)) return 'дня';
      return 'дней';
    },
    ...mapActions(['navigateToPay']),
    pay() {
      this.navigateToPay();
    }
  }
}
</script>

<template>
  <section 
    class="banner"
    v-if="$store.state.role === 'guest'"
  >
    <div class="banner__title">
      <!-- <img class="banner__title__image" src="@/assets/unlocked.png" alt=""> -->
      <h2>
        Открой весь функционал платформы!
      </h2>
    </div>
    <p class="banner__subtitle">
      Получите доступ ко всем программам, страницам и премиум-опциям сразу после оплаты.
    </p>
    <div class="banner__time">
      <img class="banner__time__image" src="@/assets/hourglass.png" alt="hour glass">
      <p>
        Осталось {{ daysLeft }} {{ getDayWord(daysLeft) }} вашего гостевого доступа.
      </p>
    </div>
    <article class="banner__pay">
      <button @clikc="pay()">
        Купить полную версию
      </button>
    </article>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  background: linear-gradient(90deg, rgba(255,152,0,1) 0%, rgba(244,67,54,1) 50%, rgba(255,235,59,1) 100%);
  padding: 1rem 1.5rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 90%;
  position: fixed;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9002;

  @media (min-width:768px) {
    display: none;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 1rem;

    &__image {
      width: 3rem;
    }

    h2 {
      font-size: min(max(16px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
      font-weight: 600;
      margin: 0;
    }
  }
  &__subtitle {
    font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 18px);
    font-weight: 500;
  }
  &__time {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    &__image {
      width: 16px;
    }
    p {
      font-size: min(max(12px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 16px);
      color: white;
    }
  }
  &__pay {
    width: 100%;
    display: flex;
    justify-content: end;
    
    button {
      border: none;
      border-radius: 10px;
      padding: 8px 12px;
      background-color: red;
      color: white;
      font-size: 12px;
    }
  }
}
</style>

